import React from 'react';

import ChevronLeftRounded from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded';

import colors from '../../util/colors';

import './styles.scss';

export const AppCarouselIndicators = ({
  items,
  activeIndex,
  componentIndex,
  className,
  showNavIcons,
  setComponentIndex,
  onSelect,
  buStyles,
  currentStyles,
}: any) => {
  const currentIndex = activeIndex || componentIndex;

  const renderNavIcons = (direction: string) => {
    return (
      items.length > 1 && (
        <div
          className="nav-icon-div"
          onClick={() => handleNavIconClick(direction)}>
          {direction === 'prev' ? (
            <ChevronLeftRounded
              className="nav-icon"
              htmlColor={buStyles.primaryColor || colors.blue}
            />
          ) : (
            <ChevronRightRounded
              className="nav-icon"
              htmlColor={buStyles.primaryColor || colors.blue}
            />
          )}
        </div>
      )
    );
  };

  const handleNavIconClick = (direction: string) => {
    if (direction == 'prev' && componentIndex != 0)
      handleSelect(componentIndex - 1);
    if (direction == 'next' && componentIndex != items.length - 1)
      handleSelect(componentIndex + 1);
  };

  const handleSelect = (selectedIndex: number) => {
    console.log(selectedIndex);

    setComponentIndex(selectedIndex);

    onSelect && onSelect(selectedIndex);
  };

  return items.length > 1 ? (
    <ol className={className}>
      {showNavIcons && renderNavIcons('prev')}
      {items.map((item: any, index: any) => (
        <li
          key={index}
          onClick={() => {
            handleSelect(index);
          }}
          className={index === currentIndex ? 'active' : ''}
          style={{
            backgroundColor:
              index !== currentIndex && currentStyles.primaryColor,
          }}
        />
      ))}
      {showNavIcons && renderNavIcons('next')}
    </ol>
  ) : null;
};
